// import { get } from "lodash";

export default {
  getSmsList: (state) => state.sms.smsList,
  getSmsDetails: (state) => state.sms.smsDetails,
  getSmsLanguageOptions: (state) => state.sms.languageOptions,
  getSmsRecipientOptions: (state) => state.sms.recipientOptions,
  // getSmsListFilters: (state) => state.sms.smsListFilters,
};
